.square {
    width: 12px;
    height: 12px;
    border-radius: 4px;
}
